/**
 * The one way a credit amount is written on screen: grouped the Indian way,
 * as the backend writes it in its own sentences (1,30,000), so a balance in
 * the sidebar chip, the upload step, the picker and Robbie's refusal all read
 * the same number the same way.
 */
export const formatCredits = (value: number): string => value.toLocaleString('en-IN');
